import {useEffect, useState} from 'react';

const DESKTOP_BREAKPOINT = 992; // kt-lg
const DESKTOP_PAGE_SIZE = 10;
const MOBILE_PAGE_SIZE = 5;

const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

const useResponsivePageSize = (): number => {
  const [pageSize, setPageSize] = useState<number>(
    isDesktop() ? DESKTOP_PAGE_SIZE : MOBILE_PAGE_SIZE
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`);

    const handleChange = (e: MediaQueryListEvent) => {
      setPageSize(e.matches ? DESKTOP_PAGE_SIZE : MOBILE_PAGE_SIZE);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return pageSize;
};

export default useResponsivePageSize;
